<input type="file" (change)="handleFile($event)" /><p>icc works!</p>
<div id="original">

</div>
<div id="resized">

</div>
<lib-button (click)="pickFiles()">Wybierz plik</lib-button>
<img [src]="currentImageUrl$ | async" [ngClass]="{picked:$safeNavigationMigration((currentImage | async)?.picked)}" />

<div class="menu" [ngClass]="{picked:$safeNavigationMigration((currentImage | async)?.picked),recommended:$safeNavigationMigration((currentImage | async)?.recommended)}">

  <div class="content">
    <div class="close">

      <li>Zamknij<span><mat-icon>close</mat-icon></span></li>

    </div>
    <ol>
      <li>Wybrane: <span>{{pickedImagesCount$ | async}}</span></li>
      <li>Aktualne zdjęcie <span>{{currentIndex$ | async}}</span></li>
      <li>Wszystkie zdjęcia <span>{{(filesToBrowse$ | async)?.length}}</span></li>
      <li>Nowa selekcja z wybranych<span><mat-icon>replay</mat-icon></span></li>
      <li>Zapisz wybór<span><mat-icon>check_circle</mat-icon></span></li>


    </ol>
    <div class="shortcuts">
      <li>B/W<span>B</span></li>
      <li>Kolejne zdjęcie<span><mat-icon>arrow_forward</mat-icon></span></li>
      <li>Poprzednie zdjęcie<span><mat-icon>arrow_back</mat-icon></span></li>
      <li>Wybierz zdjęcie<span><mat-icon>arrow_upward</mat-icon></span></li>
      <li>Odrzuć zdjęcie<span><mat-icon>arrow_downward</mat-icon></span></li>
      <li>Rekomenduj<span><mat-icon>space_bar</mat-icon></span></li>
    </div>
  </div>
</div>
